import React, { Suspense, Component } from 'react';
import Spore from "components/spore/Spore.js"
import axios from 'axios';
import AudioRecorder from './recorderWorker.js';
import recorderWorker from './recorderWorker.js';
import 'bootstrap/dist/css/bootstrap.css';
import { StaticRouter, withRouter, Route, Switch } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';
import { Badge, Label, Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import logo from './logo.svg';
import './App.css';

import SynthzPage from "components/synthz/SynthzPage.js";
const NFTsPage = React.lazy(() => import("./components/nft/NFTsPage.js"));
const Contour = React.lazy(() => import('./components/contour/Contour.js'));
const IPFSDownloader = React.lazy(() => import('./components/download/IPFSDownloader.js'));
const ExportFull = React.lazy(() => import('./components/headless/ExportFull.js'));
const Uploader = React.lazy(() => import('./components/upload/Uploader.js'));
const PinnerComponent = React.lazy(() => import('./components/PinnerComponent.js'));
const Exhibit = React.lazy(() => import("./components/exhibit/Exhibit.js"));
const LandingPage = React.lazy(() => import('./components/landing/LandingPage.js'));
const GuildsPage = React.lazy(() => import('./components/guilds/GuildsPage.js'));
const UserComponent = React.lazy(() => import('./components/user/UserComponent.js'));
const TagsOrganizerComponent = React.lazy(() => import('./components/tags/TagsOrganizerComponent.js'));
const Downloader = React.lazy(() => import('./downloader.js'));
const SoundUpload = React.lazy(() => import('./components/SoundUpload.js'));
const Discover = React.lazy(() => import('./components/discover/Discover.js'));
const MainView = React.lazy(() => import("./components/v3/MainView.js"));
const CollectPage = React.lazy(() => import("./components/collect/CollectPage.js"));
const NFTViewer = React.lazy(() => import("./components/nft/NFTViewer.js"));
const ExplorePage = React.lazy(() => import('./components/explore/ExplorePage.js'));

class App extends Component {
    constructor(props) {
        super(props);
    }

   render() {
       //window.isNFT = true;
       //window.projectId = "QmZtwDXtcSN7HWBFJVf38qaxJycdpQsbRdJCporRbRtJhQ";
       // window.projectId="QmYt9eP2ACwnCJqqw2KEoHttBfiFnx9hpNG5KC397TxUy4";
       if (window.isNFT) {
           return (
            <Suspense fallback={() => <div>Loading...</div>}>
               <BrowserRouter>
                 <Switch>
                   <Route  path="/"
                           render={(props) => <NFTViewer {...props} store={this.props.store}/>}/>
                 </Switch>
               </BrowserRouter>
            </Suspense>)
           ;

       }
       window.spores = true;
       if (window.spores) {
           return (
               <Suspense fallback={() => <div>Loading...</div>}>
                 <BrowserRouter>
                   <Route  path="/" 
                           render={(props) => <Spore {...props} store={this.props.store}/>}/>
                 </BrowserRouter>
               </Suspense>);
       }
       

        return (
            <Suspense fallback={() => <div>Loading...</div>}>
                <BrowserRouter>
                <Switch>
                   <Route  path="/nftviewer/:sequenceId"
                           render={(props) => <NFTViewer {...props} store={this.props.store}/>}/>
                   <Route  path="/screenshot/:sequenceId"
                           render={(props) => <NFTViewer {...props} screenshot={true} store={this.props.store}/>}/>
                  <Route  path="/user/:userId"
                          render={(props) => <UserComponent {...props} store={this.props.store}/>}/>
                  <Route  path="/user/"
                          render={(props) => <UserComponent {...props} store={this.props.store}/>}/>
                  <Route  path="/exhibit/:sequenceId"
                          render={(props) => <Exhibit {...props} store={this.props.store}/>}/>
                  <Route  path="/exhibit/"
                          render={(props) => <Exhibit {...props} store={this.props.store}/>}/>
                <Route  path="/explore/:sequenceId" 
                        render={(props) => <ExplorePage {...props} store={this.props.store}/>}/>
                <Route  path="/explore/" 
                        render={(props) => <ExplorePage {...props} store={this.props.store}/>}/>
                <Route  path="/contour/" 
                        render={(props) => <Contour {...props} store={this.props.store}/>}/>
                <Route  path="/spore/" 
                        render={(props) => <Spore {...props} store={this.props.store}/>}/>
                <Route  path="/nft/" 
                        render={(props) => <NFTsPage {...props} store={this.props.store}/>}/>
                <Route  path="/exportfull/:sequenceId" 
                        render={(props) => <ExportFull {...props} store={this.props.store}/>}/>
                <Route  path="/guilds/"
                        render={(props) => <GuildsPage {... props} store={this.props.store}/>}
                  />
                  <Route  path="/tags/"
                          render={(props) => <TagsOrganizerComponent {... props} store={this.props.store}/>}/>
                <Route  path="/synthz/"
                        render={(props) => <SynthzPage {...props} store={this.props.store}/>}/>
                <Route  path="/v3/:sequenceId" 
                        render={(props) => <MainView {...props} store={this.props.store}/>}/>
                <Route  path="/collect/:userName"
                        render={(props) => <CollectPage {...props} store={this.props.store}/>}/>
                <Route  path="/collect/"
                        render={(props) => <CollectPage {...props} store={this.props.store}/>}/>
                <Route  path="/v3/"
                        render={(props) => <MainView {...props} store={this.props.store}/>}/>
                <Route  path="/download/"
                        render={(props) => <IPFSDownloader {...props} store={this.props.store}/>}/>
                <Route  path="/upload/"
                        render={(props) => <SoundUpload {...props} store={this.props.store}/>}/>
                <Route  path="/uploader/"
                        render={(props) => <Uploader {...props} store={this.props.store}/>}/>
                <Route  path="/discover/"
                        render={(props) => <Discover {...props} store={this.props.store}/>}/>
                  <Route  path="/"
                     render={(props) => <LandingPage {...props} store={this.props.store}/>}/> 
                  {/*<Route  path="/"
                     render={(props) => <Exhibit {...props} store={this.props.store}/>}/>*/}
                <Route  path="/documentation"
                        render={(props) => <LandingPage {...props} showDocumentation={true} store={this.props.store}/>}/>
                </Switch>
                </BrowserRouter>
            </Suspense>
                );
    }
}

export default App;

function getLink(videoId) {
    return "https://www.youtube.com/watch?v=" + videoId;
}

